export function captureLeafletViewport(map) {
  if (!map || typeof map.getCenter !== "function" || typeof map.getZoom !== "function") return null;
  try {
    const center = map.getCenter();
    const bounds = typeof map.getBounds === "function" ? map.getBounds() : null;
    const snapshot = {
      center: [Number(center.lat), Number(center.lng)],
      zoom: Number(map.getZoom()),
    };
    if (bounds && typeof bounds.getSouthWest === "function" && typeof bounds.getNorthEast === "function") {
      const sw = bounds.getSouthWest();
      const ne = bounds.getNorthEast();
      snapshot.bounds = {
        southWest: [Number(sw.lat), Number(sw.lng)],
        northEast: [Number(ne.lat), Number(ne.lng)],
      };
    }
    return snapshot;
  } catch (_) {
    return null;
  }
}

export function cloneSnapshot(value) {
  try {
    return JSON.parse(JSON.stringify(value));
  } catch (_) {
    return {};
  }
}

export function buildDefaultReportTitle(parts) {
  return (Array.isArray(parts) ? parts : [])
    .map((part) => String(part || "").trim())
    .filter(Boolean)
    .join(" - ");
}

export function mapLegendToSnapshot(legendItems) {
  return (Array.isArray(legendItems) ? legendItems : [])
    .map((item) => ({
      label: String(item.label || ""),
      color: String(item.color || ""),
    }))
    .filter((item) => item.label || item.color);
}

